// Keep in sync with variables.less
export const PHONE_WIDTH = 480;
export const TABLET_WIDTH = 768;
export const DESKTOP_WIDTH = 992;
export const LG_DESKTOP_WIDTH = 1200;

export const PHONE_MAX_WIDTH = TABLET_WIDTH - 1;
export const TABLET_MAX_WIDTH = DESKTOP_WIDTH - 1;
export const DESKTOP_MAX_WIDTH = LG_DESKTOP_WIDTH - 1;
